/* Add to cart */
let selectedVariantId = null;
const forms = document.querySelectorAll('.deo_wrapper');

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const cartMessage = form.querySelector('.order');
    const outOfStockMessage = form.querySelector('.stock');
    const ordersButton = form.querySelectorAll('.orders');
    const addedButton = form.querySelectorAll('.added');

    if (selectedVariantId) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] }),
        });

        if (response.status === 422) {
          return null;
        } else {
          const data = await response.json();
          cartQuant();
          if (data && cartMessage) {
            cartMessage.classList.add('active');
            ordersButton.forEach((button) => button.classList.add('hide'));
            addedButton.forEach((button) => button.classList.add('active'));
            if (outOfStockMessage) outOfStockMessage.classList.add('hide');
          }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  });
});

/* Intersection Animations */

function handleEntry(entry, observer) {
  if (entry.isIntersecting) {
    if (
      entry.intersectionRatio >= 0.3 &&
      (entry.target.classList.contains('desc_order_wrapper') ||
        entry.target.classList.contains('subsect_images') ||
        entry.target.classList.contains('reel_cta_wrapper') ||
        entry.target.classList.contains('info_images') ||
        entry.target.classList.contains('info_header_paragraph') ||
        entry.target.classList.contains('about_img_4') ||
        entry.target.classList.contains('about_img_3') ||
        entry.target.classList.contains('about_subheader') ||
        entry.target.classList.contains('desc_image_tag') ||
        entry.target.classList.contains('about_tablets') ||
        entry.target.classList.contains('science_info_paragraph') ||
        entry.target.classList.contains('sub_sect_header') ||
        entry.target.classList.contains('science_pill') ||
        entry.target.classList.contains('subsect_gallery_images'))
    ) {
      entry.target.classList.add('anim_cta');
      observer.unobserve(entry.target);
    } else if (
      entry.intersectionRatio >= 0.3 &&
      (entry.target.classList.contains('desc_tablet') ||
        entry.target.classList.contains('desc_paragraph') ||
        entry.target.classList.contains('reel_text') ||
        entry.target.classList.contains('subsect_pills') ||
        entry.target.classList.contains('science_tag') ||
        entry.target.classList.contains('science_pill_header') ||
        entry.target.classList.contains('science_info_header'))
    ) {
      entry.target.classList.add('anim_text');
      observer.unobserve(entry.target);
    } else if (
      entry.intersectionRatio >= 0.31 &&
      (entry.target.classList.contains('desc_image_one') ||
        entry.target.classList.contains('desc_image_two') ||
        entry.target.classList.contains('science_images'))
    ) {
      entry.target.classList.add('anim_img');
      observer.unobserve(entry.target);
    } else if (entry.intersectionRatio >= 0.3 && entry.target.classList.contains('about_img_1_2')) {
      entry.target.classList.add('anim_img_2');
      observer.unobserve(entry.target);
    }
  }
}

const options = {
  root: null,
  rootMargin: '0px',
  threshold: [0, 0.25, 0.35],
};

const classes = [
  '.desc_tablet',
  '.desc_paragraph',
  '.reel_text',
  '.desc_order_wrapper',
  '.subsect_images',
  '.reel_cta_wrapper',
  '.info_images',
  '.info_header_paragraph',
  '.about_img_4',
  '.about_img_3',
  '.about_subheader',
  '.desc_image_tag',
  '.about_tablets',
  '.desc_image_one',
  '.desc_image_two',
  '.about_img_1_2',
  '.subsect_pills',
  '.sub_sect_header',
  '.science_info_paragraph',
  '.science_images',
  '.science_pill',
  '.science_tag',
  '.science_pill_header',
  '.science_info_header',
  '.subsect_gallery_images',
];

const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach((entry) => handleEntry(entry, obs));
}, options);

classes.forEach((className) => {
  document.querySelectorAll(className).forEach((element) => {
    observer.observe(element);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  /* Image low-res placholders */
  const images = document.querySelectorAll('img[data-srcset]');
  images.forEach((img) => {
    const highResSrcset = img.getAttribute('data-srcset');
    const highResImage = new Image();
    highResImage.srcset = highResSrcset;
    highResImage.sizes = img.getAttribute('sizes');
    highResImage.onload = () => {
      img.srcset = highResSrcset;
    };
  });

  /* Prevent email footer submission refresh */
  const form = document.getElementById('emailForm');
  const submitButton = document.getElementById('submitButton');

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(form);
    fetch('/contact', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          localStorage.setItem('emailSubmitted', 'true');
          submitButton.textContent = 'WELCOME';
        } else {
          console.error('Submission failed');
        }
      })
      .catch((error) => {
        console.error('An error occurred:', error);
      });
  });
});

/* Footer Links Dropdown Animations */
function toggleFooterLinks(linksId, arrowLinksId) {
  var info = document.getElementById(linksId);
  var arrow = document.getElementById(arrowLinksId);

  if (arrow) {
    arrow.classList.toggle('rotate');
  }

  if (info) {
    if (info.style.height === '0px' || info.style.height === '') {
      const scrollHeight = info.scrollHeight;
      info.style.height = scrollHeight + 6 + 'px';
      info.style.opacity = 1;
    } else {
      info.style.height = '0';
      info.style.opacity = 0;
    }
  }
}
